import { render, staticRenderFns } from "./installRecord.vue?vue&type=template&id=3fe6a662&scoped=true&"
import script from "./installRecord.vue?vue&type=script&lang=js&"
export * from "./installRecord.vue?vue&type=script&lang=js&"
import style0 from "./installRecord.vue?vue&type=style&index=0&id=3fe6a662&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6a662",
  null
  
)

export default component.exports